import f from "@ui-kit/components/modal";
import S from "@ui-kit/components/button";
import { defineComponent as b, ref as E, resolveComponent as y, openBlock as v, createElementBlock as A, createVNode as a, unref as t, withCtx as h, createBlock as I } from "vue";
import { faXmark as M } from "@fortawesome/pro-regular-svg-icons";
import { useCurrentProviderKey as B, useProviderI18n as j } from "@versatile-credit-apply/sdk";
import { useSessionTimeout as T } from "@versatile-credit-apply/composition";
import { useEventListener as U } from "@vueuse/core";
import { useI18n as V } from "vue-i18n";
const g = /* @__PURE__ */ b({
  __name: "FlowExitButton",
  props: {
    modalSeverity: { default: "error" },
    buttonSeverity: { default: "secondary" }
  },
  emits: ["exit"],
  setup(o, { emit: e }) {
    const i = E(!1), l = () => i.value = !0, r = B(), { t: n } = j(r), s = e, c = () => s("exit");
    return (u, m) => {
      const x = S, w = y("i18n-t"), k = f;
      return v(), A("div", null, [
        a(x, {
          icon: t(M),
          severity: o.buttonSeverity,
          text: "",
          class: "text-xl focus:ring-1",
          "aria-label": "Exit Application",
          onClick: l
        }, null, 8, ["icon", "severity"]),
        a(k, {
          modelValue: i.value,
          "onUpdate:modelValue": m[0] || (m[0] = (C) => i.value = C),
          severity: o.modalSeverity,
          header: t(n)("confirm_cancel_heading"),
          "cancel-button-label": t(n)("confirm_modal_reject"),
          "accept-button-label": t(n)("confirm_modal_accept"),
          onModalAccept: c
        }, {
          default: h(() => [
            a(w, {
              keypath: "confirm_cancel_message",
              tag: "p"
            })
          ]),
          _: 1
        }, 8, ["modelValue", "severity", "header", "cancel-button-label", "accept-button-label"])
      ]);
    };
  }
});
function _(o) {
  const e = o;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      confirm_cancel_heading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Exit Application?
` } },
      confirm_cancel_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This will end your current application session." } },
      confirm_modal_accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes Exit" } },
      confirm_modal_reject: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
    }
  });
}
function p(o) {
  const e = o;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "tdbank_standard_en",
    resource: {
      confirm_cancel_heading: { t: 0, b: { static: "", t: 2, i: [] } },
      confirm_cancel_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `Are you sure you don't want to apply? If you leave the credit application now, all the info you've entered will be lost.
` } },
      confirm_modal_accept: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes, I'm Sure" } },
      confirm_modal_reject: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Keep Applying" } }
    }
  });
}
typeof _ == "function" && _(g);
typeof p == "function" && p(g);
const $ = /* @__PURE__ */ b({
  __name: "SessionTimeoutModal",
  setup(o) {
    const { t: e } = V(), { reset: i, displayWarning: l } = T();
    return U(
      document,
      ["keydown", "keyup", "mousedown", "mouseup", "mousemove"],
      () => {
        l.value || i(!1);
      }
    ), (r, n) => {
      const s = y("i18n-t"), c = f;
      return v(), I(c, {
        "model-value": t(l),
        severity: "warning",
        header: t(e)("session.timeout_warning.heading"),
        "accept-button-label": t(e)("actions.still_here.label"),
        "cancel-button-label": t(e)("actions.exit.label"),
        onModalAccept: n[0] || (n[0] = (u) => t(i)(!1)),
        onModalReject: n[1] || (n[1] = (u) => t(i)(!0))
      }, {
        default: h(() => [
          a(s, {
            keypath: "session.timeout_warning.message",
            tag: "p"
          })
        ]),
        _: 1
      }, 8, ["model-value", "header", "accept-button-label", "cancel-button-label"]);
    };
  }
});
function d(o) {
  const e = o;
  e.__i18n = e.__i18n || [], e.__i18n.push({
    locale: "en",
    resource: {
      actions: {
        exit: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Exit" } }
        },
        still_here: {
          label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Still Here" } }
        }
      },
      session: {
        timeout_warning: {
          heading: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Are you still there?" } },
          message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: `You are about to be timed out which will clear all of your
personal information from the device and exit the session.
` } }
        }
      }
    }
  });
}
typeof d == "function" && d($);
export {
  g as FlowExitButton,
  $ as SessionTimeoutModal
};
//# sourceMappingURL=index.es.js.map
